import { IResearchWorkItem } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export interface IAddResearchWorkItemNoteRequest {
  workItemId: string;
  version: number;
  note: string;
}

export const addResearchWorkItemNote = async ({
  workItemId,
  version,
  note,
}: IAddResearchWorkItemNoteRequest): Promise<IResearchWorkItem> => {
  const response = await apiClient.post(
    `/research/work-items/${workItemId}/notes`,
    { version, note }
  );

  return response.data;
};
